var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CopyrightSection"},[_c('ShDividerLine'),_vm._v("\n  Copyright © 2019 Telestrada S.A. - wszelkie prawa zastrzeżone\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }